// extracted by mini-css-extract-plugin
export default {"wrapper":"onboard_wrapper__l45N+"};